import React, { useState } from 'react';
import { type SankeyNode } from '@src/pages/journey-map/types';

interface NodeProps {
  node: SankeyNode;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onDoubleClick: () => void;
}

const Node: React.FC<NodeProps> = ({ node, onMouseEnter, onMouseLeave, onDoubleClick }) => {
  const { x0, x1, y0, y1 } = node;
  const width = x1 - x0;
  const height = y1 - y0;
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
    onMouseEnter?.();
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    onMouseLeave?.();
  };

  return (
    <g
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onDoubleClick={onDoubleClick}
    >
      <rect
        x={x0}
        y={y0}
        width={Math.max(50, width)}
        height={Math.max(10, height + 1)}
        fill="#4a90e2"
        opacity={isHovered ? 1 : 0.8}
        style={{ transition: 'opacity 0.2s ease' }}
      >
        <title>Double click see details</title>
      </rect>
    </g>
  );
};

export default Node;
